<script setup lang="ts">
import { FetchTicketResponseStatus, type StatusResponse } from 'src/api/models';


interface Props {
  status: FetchTicketResponseStatus | StatusResponse;
}

const props = defineProps<Props>();

const getSeverityIcon = (status: FetchTicketResponseStatus) => {
  switch (status) {
    case FetchTicketResponseStatus.closed:
      return 'pi-check-circle';
    case FetchTicketResponseStatus.new:
      return 'pi-exclamation-triangle';
    case FetchTicketResponseStatus.ongoing:
      return 'pi-spinner';
    default:
      return '';
  }
};

const getSeverityColorClass = (status: FetchTicketResponseStatus) => {
  switch (status) {
    case FetchTicketResponseStatus.closed:
      return 'text-green-500';
    case FetchTicketResponseStatus.new:
      return 'text-yellow-500';
    case FetchTicketResponseStatus.ongoing:
      return 'text-blue-500';
    default:
      return '';
  }
};

</script>

<template>
  <i
    v-if="getSeverityIcon(status)"
    v-tooltip="status"
    class="pi"
    :class="[getSeverityIcon(status), getSeverityColorClass(status)]"
  />
</template>
